import { MissDiorOrange } from "./MissDior/MissDiorOrange.jsx";

import { useThree } from "@react-three/fiber";
import { useStore } from "../../store/store.jsx";
import {
  Environment,
  OrbitControls,
  MeshReflectorMaterial,
} from "@react-three/drei";
import { useControls } from "leva";
import { useEffect } from "react";

const WebGL = () => {
  const {
    rotationX,
    rotationZ,
    scale,
    env,
    color,

    mixBlur,
    mixStrength,
    mixContrast,
    resolution,
    mirror,
    depthScale,
    minDepthThreshold,
    maxDepthThreshold,
    metalness,
    reflectorOffset,
  } = useControls("chair", {
    scale: {
      value: 1.16,
      step: 0.01,
    },
    rotationX: {
      value: 0.15,
      step: 0.01,
      min: 0,
      max: Math.PI,
    },
    rotationZ: {
      value: 0,
      step: 0.01,
      min: 0,
      max: Math.PI,
    },
    env: {
      options: ["city", "sunset", "studio"],
    },
    color: {
      value: "#d8d8d8",
    },

    mixBlur: {
      value: 1,
      step: 0.01,
      min: 0,
      max: 1,
    },
    mixStrength: {
      value: 0.5,
      step: 0.01,
      min: 0,
      max: 1,
    },
    mixContrast: {
      value: 1,
      step: 0.01,
      min: 0,
      max: 1,
    },
    resolution: {
      value: 512,
      step: 1,
      min: 0,
      max: 2048,
    },
    mirror: {
      value: 1,
      step: 0.01,
      min: 0,
      max: 1,
    },
    depthScale: {
      value: 0,
      step: 0.01,
      min: 0,
      max: 10,
    },
    minDepthThreshold: {
      value: 1,
      step: 0.01,
      min: 0,
      max: 1,
    },
    maxDepthThreshold: {
      value: 1,
      step: 0.01,
      min: 0,
      max: 1,
    },
    metalness: {
      value: 1,
      step: 0.01,
      min: 0,
      max: 1,
    },
    reflectorOffset: {
      value: 0,
      step: 0.1,
      min: 0,
      max: 100,
    },
  });
  const { viewport } = useThree();

  const storeEnv = useStore((state) => state.storeEnv);

  return (
    <>
      <OrbitControls />
      <Environment files={storeEnv ? storeEnv : null} />

      <MissDiorOrange
        position={[0, -0.5, 3.75]}
        rotation-x={rotationX}
        rotation-z={rotationZ}
        offset={0}
        scale={window.innerWidth < 1024 ? scale * 0.9 : scale}
      />

      <mesh position={[0, -0.6, 4]} rotation={[-Math.PI / 2, 0, 0]}>
        <planeGeometry args={[viewport.width, 2]} />
        <MeshReflectorMaterial
          blur={[800, 800]} // Blur ground reflections (width, height), 0 skips blur
          mixBlur={mixBlur} // How much blur mixes with surface roughness (default = 1)
          mixStrength={mixStrength} // Strength of the reflections
          mixContrast={mixContrast} // Contrast of the reflections
          resolution={resolution} // Off-buffer resolution, lower=faster, higher=better quality, slower
          mirror={mirror} // Mirror environment, 0 = texture colors, 1 = pick up env colors
          depthScale={depthScale} // Scale the depth factor (0 = no depth, default = 0)
          minDepthThreshold={minDepthThreshold} // Lower edge for the depthTexture interpolation (default = 0)
          maxDepthThreshold={maxDepthThreshold} // Upper edge for the depthTexture interpolation (default = 0)
          color={color}
          metalness={metalness}
          reflectorOffset={reflectorOffset} // Offsets the virtual camera that projects the reflection. Useful when the reflective surface is some distance from the object's origin (default = 0)
        />
      </mesh>
    </>
  );
};

export default WebGL;
